var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._b({class:{
    blocks: !_vm.hasSpacingSlices,
    'blocks--no-default-spacing': _vm.hasSpacingSlices,
    'blocks--gallery': _vm.hasGallery,
  }},'div',_vm.blocksAttributes,false),_vm._l((_vm.visibleBlocks),function(block,index){return _c(_vm.getComponent(block._type),_vm._b({key:block._key,tag:"component",attrs:{"id":block._key,"block":block,"first-block":index === 0,"is-home":_vm.isHome},on:{"in":function($event){return _vm.blockInScreenDetected(index)},"out":function($event){return _vm.blockOffScreenDetected(index)}}},'component',_vm.getAttributes(block, index),false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }